const Card = (props) => {
    return(
       <>
       <div className="card backco">
               <div>
                   <img src="" alt=""/>
               </div>
           <div className="card-body ">
                   <div className=" d-flex justify-content-between">
                       
                   <h4 className="text-light">
                   {props.head} {props.head1} {props.head2} {props.head3} 
                   </h4>
                   <p className="">
                       {props.chartIcons}{props.chartIcons1}{props.chartIcons2}{props.chartIcons3 }
                   </p>
                   </div>
                   <h5 className=" pb-2 text-light">
                       {props.subhead} {props.subhead1} {props.subhead2} {props.subhead3} 
                   </h5>
                   <h6 className=" pt-2 pb-2 background ps-2">
                      {props.suboffheading}  {props.suboffheading1}  {props.suboffheading2}  {props.suboffheading3}
                   </h6>
                   
           </div>
           
       </div>
          
       
       </>
    )
   }
   export default Card;